import { combineEpics } from 'redux-observable';

import getAppStatus from './getAppStatus';

export default combineEpics(getAppStatus);
